import { MAX_SHORT_NAME, FEEDS } from '#/shared/constants';

export const PAY_TEMPLATES = {
  RIDE_FREE: 'ride-free',
  TAP_WHEN_BOARDING: 'tap-when-boarding',
  TAP_BEFORE_BOARDING: 'tap-before-boarding',
  TRAM_PAYMENT_INFO: 'tram-payment-info',
  PAY_CASH_OR_PASS: 'pay-cash-or-pass',
  PAY_CASH_OR_UMO: 'pay-cash-or-umo',
} as const;

export const AGENCY_LINKS = {
  RIDECONNECTION_CONNECTORS:
    'https://rideconnection.org/services/community-connectors/',
  RIDECONNECTION_HOME: 'https://rideconnection.org/',
  CLACKAMAS_CONNECTS: 'https://www.clackamas.us/h3s/connects-shuttle',
  WAPARK_SHUTTLE: 'https://explorewashingtonpark.org/free-shuttle/',
  MULT_TRANSIT: 'https://multco.us/programs/transit',
  SAM_RIDES:
    'https://www.ci.sandy.or.us/transit/page/sam-rides-demand-response-dial-ride-service',
  CTRAN_CURRENT: 'https://c-tran.com/thecurrent',
  WASH_FLEX: 'https://catchthespot.org/',
} as const;

export const PAYING_ON = {
  TRIMET: {
    FX2: 'paying-on-trimet-fx',
    [MAX_SHORT_NAME]: 'paying-on-trimet-max',
    WES: 'paying-on-trimet-wes',
    STREETCAR: 'paying-on-portland-streetcar', // A,B,NS,S
    AT: 'paying-on-portland-aerial-tram',
    BUS: 'paying-on-trimet-buses',
  },
  CTRAN: {
    VINE: 'paying-on-ctran-the-vine',
    BUS: 'paying-on-ctran-buses',
  },
  CTRAN_FLEX: 'paying-on-ctran-the-current',
  OTHER: {
    CLACKAMAS: 'paying-on-clackamas',
    MULT: 'paying-on-multco',
    RIDECONNECTION: 'paying-on-rideconnection',
    SMART: 'paying-on-smart',
    WAPARK: 'paying-on-wapark',
  },
} as const;

export const LINK_TEXT = {
  TRIMET: {
    STREETCAR: 'learn-more-about-streetcar-fares',
    AT: 'buy-aerial-tram-tickets-online',
    DEFAULT: 'learn-more-about-trimet-fares',
  },
  CTRAN: {
    VINE: 'learn-more-about-vine-fares',
    DEFAULT: 'learn-more-about-ctran-fares',
  },
  CTRAN_FLEX: 'learn-more-about-current-fares',
} as const;

export const SAM_FLEX_ROUTE_IDS = ['77124'];
export const SAM_FLEX_GTFS_ROUTE_IDS = SAM_FLEX_ROUTE_IDS.map(
  routeId => `${FEEDS.SAM}:${routeId}`
);

// Options for how the trip time is used in a trip plan
export const DEPART_AT_OPTION = 'DEPART';
export const ARRIVE_BY_OPTION = 'ARRIVE';
export const LEAVE_NOW_OPTION = 'LEAVE_NOW';
